module.exports = __webpack_public_path__ + "img/gigwicat5.aaef3f18.jpg";